import { Component } from '@angular/core';

@Component({
  selector: 'app-successful-signup',
  standalone: false,
  templateUrl: './successful-signup.component.html',
  styleUrl: './successful-signup.component.css',
})
export class SuccessfulSignupComponent {}
